import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../motion/Reveal";

export default function CTA() {
  return (
    <section
      className="relative overflow-hidden bg-brand-primary text-white py-24 lg:py-36"
      data-testid="cta-section"
    >
      <div className="absolute inset-0 bg-grid opacity-40 pointer-events-none" aria-hidden />
      <div
        aria-hidden
        className="absolute -top-40 left-1/2 -translate-x-1/2 w-[1000px] h-[1000px] rounded-full glow-radial"
      />
      <div className="absolute inset-0 grain pointer-events-none" aria-hidden />

      <div className="relative max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <Reveal>
          <p className="eyebrow text-brand-accent">Bereit für den nächsten Schritt?</p>
        </Reveal>
        <Reveal delay={0.05}>
          <motion.h2 className="mt-6 font-display font-medium text-4xl sm:text-6xl lg:text-[5.5rem] leading-[1] tracking-tighter max-w-5xl mx-auto text-balance">
            Lassen Sie uns gemeinsam Ihr Unternehmen digital nach vorne bringen.
          </motion.h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
            <a
              href="#kontakt"
              className="btn-primary"
              data-testid="cta-primary"
            >
              Jetzt kostenlos beraten lassen
              <ArrowUpRight className="h-4 w-4" />
            </a>
            <a
              href="mailto:hallo@metalotsen.de"
              className="btn-secondary btn-secondary--dark"
              data-testid="cta-secondary"
            >
              Direkt schreiben
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
